module.exports = __webpack_public_path__ + "static/media/ic_template_3.e5f5b664.png";